import React from 'react';
import { css } from '@emotion/react';
import { i18n_start_7_day_free_trial__v2 } from '@yi/i18n/phrases/i18n_start_7_day_free_trial__v2';

import { Button, styles as baseButtonStyles } from '~/src/components/buttons';
import { useLocale } from '~/src/components/LocaleProvider';
import { breakpoints } from '~/src/styles';

import { LocalizedLink } from '../LocalizedLink';

const styles = {
  button: css(baseButtonStyles.fullWidth, {
    [breakpoints.minTablet]: css(baseButtonStyles.autoWidth, {
      a: css({
        paddingLeft: '64px',
        paddingRight: '64px',
      }),
      'a:hover': {
        textDecoration: 'none',
      },
    }),
  }),
  container: css({
    zIndex: 10,
    width: '100%',
    'a:hover': {
      textDecoration: 'none',
    },
    [breakpoints.minTablet]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    [breakpoints.minDesktop]: {
      justifyContent: 'start',
    },
  }),
};
export const StartFreeTrialButton: React.FC<
  {
    className?: string;
    href?: string;
    children?: React.ReactNode;
  } & Pick<React.ComponentProps<typeof Button>, 'disabled' | 'showSpinner' | 'containerCss'>
> = ({ href = '/membership', className = '', children, ...props }) => {
  const { locale } = useLocale();
  return (
    <div css={styles.container} className={className}>
      <LocalizedLink to={href}>
        <Button kind="primary" containerCss={styles.button} {...props}>
          {children ? children : i18n_start_7_day_free_trial__v2(locale)}
        </Button>
      </LocalizedLink>
    </div>
  );
};
